<template>
  <div ref="turnstileContainer" class="cf-turnstile"></div>
</template>

<script>
export default {
  name: 'CloudflareTurnstile',
  mounted() {
    this.loadTurnstile();
  },
  methods: {
    async loadTurnstile() {
      await this.loadScript('https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit');
      this.$refs.turnstileContainer.setAttribute('data-sitekey', process.env.VUE_APP_CF_TURNSTILE_KEY);
      this.$refs.turnstileContainer.setAttribute('data-theme', 'light');
      if (window.turnstile) {
        window.turnstile.render(this.$refs.turnstileContainer, {
          callback: this.handleTurnstileVerification,
        });
      }
    },
    loadScript(src) {
      return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = src;
        script.async = true;
        script.defer = true;
        script.onload = () => resolve();
        script.onerror = () => reject(new Error(`Failed to load ${src}`));
        document.head.appendChild(script);
      });
    },
    handleTurnstileVerification(token) {
      this.$emit('verified', token);
    },
  },
};
</script>

<style scoped>
.cf-turnstile {
  margin: 20px 0;
  max-height: 65px;
}
</style>
